<div class="container" style="background:lightgoldenrodyellow; padding: 1em;">


<form [formGroup]="form" class="user-form" >
    <mat-form-field  >
        <mat-placeholder ><mat-icon>number</mat-icon> {{'TOBA LIGHT.label.orderId' | translate}}</mat-placeholder>
        <input  matInput formControlName="id">
        <mat-error *ngIf="form.controls.id.hasError('minlength')">id isn't long enough, minimum of 5 characters</mat-error>
    </mat-form-field>
    <mat-form-field >
        <mat-placeholder ><mat-icon>person</mat-icon> {{'TOBA LIGHT.label.clientName' | translate}}</mat-placeholder>
        <input  matInput formControlName="clientName">
        <mat-error *ngIf="form.controls.clientName.hasError('minlength')">clientName isn't long enough, minimum of 5 characters</mat-error>
    </mat-form-field>

    <button mat-raised-button (click)="search()">{{'TOBA LIGHT.label.search' | translate}}</button>
    <button mat-raised-button (click)="clear()" color="primary">{{'TOBA LIGHT.label.clear' | translate}}</button>



</form>


</div>
